import React from "react";
import Styles from "./GuidesGrid.module.css";

import CardGuide from "./CardGuide";
import { useTranslation } from "react-i18next";
import guideDataEN from "../../i18n/translations/GuideData/GuideDataEn";
import guideDataAr from "../../i18n/translations/GuideData/GuideDataAr";
import guideDataKu from "../../i18n/translations//GuideData/GuideDataKu";

function GuidesGrid() {
	const { t, i18n } = useTranslation();

	const currentLanguage = i18n.language;
	const guideData =
		currentLanguage === "en"
			? guideDataEN
			: currentLanguage === "ar"
			? guideDataAr
			: guideDataKu;
	return (
		<>
			<h1 className={Styles.h1}>
				{t("BookyourGuide.title")}
			</h1>
			<div className={Styles.Grid}>
				{guideData.map((guide, index) => (
					<CardGuide
						className={Styles.centerCard}
						idGuide={guide.idGuide}
						name={guide.name}
						image={guide.image}
						imgCover={guide.imgCover}
						province={guide.province}
						rate={guide.rate}
						perHour={guide.perHour}
						noOfReviews={guide.noOfReviews}
						quote={guide.Quote}
						ProgramsData={guide.ProgramsData}
						UsersReviews={guide.UsersReviews}
					/>
				))}
			</div>
		</>
	);
}

export default GuidesGrid;
